import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { persistor, state } from '../store';

const PersistLoading = () => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: '100vh',
    }}
  >
    <CircularProgress />
  </Box>
);

const StoreContainer = ({ children }) => (
  <Provider store={state}>
    <PersistGate loading={<PersistLoading />} persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);

StoreContainer.propTypes = {
  children: PropTypes.node,
};

export default StoreContainer;
